'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOMPatcher = exports.h = exports.EMPTY_DIV = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Manages Virtual DOM -> DOM rendering cycle
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module dom-patcher
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @private
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _snabbdom = require('snabbdom');

var _h = require('snabbdom/h');

var _h2 = _interopRequireDefault(_h);

var _attributes = require('snabbdom/modules/attributes');

var _attributes2 = _interopRequireDefault(_attributes);

var _dataset = require('snabbdom/modules/dataset');

var _dataset2 = _interopRequireDefault(_dataset);

var _snabbdomDelayedClass = require('snabbdom-delayed-class');

var _snabbdomDelayedClass2 = _interopRequireDefault(_snabbdomDelayedClass);

var _eventlisteners = require('snabbdom/modules/eventlisteners');

var _eventlisteners2 = _interopRequireDefault(_eventlisteners);

var _props = require('snabbdom/modules/props');

var _props2 = _interopRequireDefault(_props);

var _style = require('snabbdom/modules/style');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var patch = (0, _snabbdom.init)([_attributes2.default, _dataset2.default, _snabbdomDelayedClass2.default, _eventlisteners2.default, _props2.default, _style2.default]);

var EMPTY_DIV = exports.EMPTY_DIV = (0, _h2.default)('div');
exports.h = _h2.default;

var DOMPatcher = exports.DOMPatcher = function () {
  function DOMPatcher(initialState, renderFunc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, DOMPatcher);

    this.updateMode = options.updateMode || 'async';

    this.state = Object.assign({}, initialState);
    this.renderFunc = renderFunc;
    this.vnode = this.renderFunc(this.state);

    // prepare root element
    var tagName = this.vnode.sel.split(/[#.]/)[0];
    var classMatches = this.vnode.sel.match(/\.[^.#]+/g);
    var idMatch = this.vnode.sel.match(/#[^.#]+/);
    this.el = document.createElement(tagName);
    if (classMatches) {
      this.el.className = classMatches.map(function (c) {
        return c.slice(1);
      }).join(' ');
    }
    if (idMatch) {
      this.el.id = idMatch[0].slice(1);
    }

    patch(this.el, this.vnode);
  }

  _createClass(DOMPatcher, [{
    key: 'update',
    value: function update(newState) {
      var _this = this;

      if (this.rendering) {
        console.error('Applying new DOM update while render is already in progress!');
      }

      this.pendingState = newState;
      switch (this.updateMode) {
        case 'async':
          if (!this.pending) {
            this.pending = true;
            requestAnimationFrame(function () {
              return _this.render();
            });
          }
          break;
        case 'sync':
          this.render();
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      // if disconnected, don't render
      if (!this.renderFunc) {
        return;
      }

      this.rendering = true;
      this.pending = false;
      this.state = this.pendingState;
      var newVnode = this.renderFunc(this.state);
      this.rendering = false;

      patch(this.vnode, newVnode);
      this.vnode = newVnode;
    }
  }, {
    key: 'disconnect',
    value: function disconnect() {
      var vnode = this.vnode;
      this.renderFunc = null;
      this.state = null;
      this.vnode = null;
      this.el = null;
      // patch with empty vnode to clear out listeners in tree
      // this ensures we don't leave dangling DetachedHTMLElements blocking GC
      patch(vnode, { sel: vnode.sel });
    }
  }]);

  return DOMPatcher;
}();